import {
    GET_ATTENDANCE_REPORT,
    GET_ISSUE_REPORT,
    GET_LEAVE_REPORT,
    GET_ROOM_BOOKING_REPORT,
    GET_FEEDBACK_REPORT,
    GET_BIRTHDAY_REPORT,
    GET_LOCATION_WISE_CATEGORY_ISSUE_REPORT,
    GET_STATUS_WISE_COUNT_ISSUE_REPORT,
    GET_TYPE_OF_LEAVE_APPLIED_COUNT_REPORT,
    GET_STATUS_OF_LEAVE_COUNT_REPORT,
} from "shared/constants/ActionTypes";

const initialState = {
    issueReportList: [],
    locationWiseCategoryIssueReportList: [],
    statusWiseCountIssueReportList: [],
    attendanceReportList: [],
    leaveReportList: [],
    typeOfleaveAppliedCountReportList: [],
    statusOfleaveCountReportList: [],
    roomBookingReportList: [],
    feedbackReportList: [],
    birthdayReportList: [],
};
export const reportReducer = (state = initialState, action) => {
    const { type, payload } = action;
    switch (type) {
        case GET_ISSUE_REPORT:
            return {
                ...state,
                issueReportList: payload,
            };
        case GET_LOCATION_WISE_CATEGORY_ISSUE_REPORT:
            return {
                ...state,
                locationWiseCategoryIssueReportList: payload,
            };
        case GET_STATUS_WISE_COUNT_ISSUE_REPORT:
            return {
                ...state,
                statusWiseCountIssueReportList: payload,
            };
        case GET_ATTENDANCE_REPORT:
            return {
                ...state,
                attendanceReportList: payload,
            };
        case GET_LEAVE_REPORT:
            return {
                ...state,
                leaveReportList: payload,
            };
        case GET_TYPE_OF_LEAVE_APPLIED_COUNT_REPORT:
            return {
                ...state,
                typeOfleaveAppliedCountReportList: payload,
            };
        case GET_STATUS_OF_LEAVE_COUNT_REPORT:
            return {
                ...state,
                statusOfleaveCountReportList: payload,
            };
        case GET_ROOM_BOOKING_REPORT:
            return {
                ...state,
                roomBookingReportList: payload,
            };
        case GET_FEEDBACK_REPORT:
            return {
                ...state,
                feedbackReportList: payload,
            };
        case GET_BIRTHDAY_REPORT:
            return {
                ...state,
                birthdayReportList: payload,
            };

        default:
            return state;
    }
};
